import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import { Avatar } from 'antd'
import { connect, useDispatch, useSelector } from 'react-redux'
import {
  logoutLocalScoutUser,
  toggleStartup,
  updateLocalInvestorUser,
  updateLocalStartupUser,
} from '../../../../redux/auth/authActions'
import { portalRedirection } from '../../../../redux/investorFlowControl/investorFlowControlActions'
import ReturnDashboardIcon from '../../../../assets/images/Icons/ReturnDashboardIcon'
import { ReactComponent as User } from '../../../../assets/images/scouts/user.svg'
import { ReactComponent as Settings } from '../../../../assets/images/scouts/setting.svg'
import { ReactComponent as LogOut } from '../../../../assets/images/scouts/logout.svg'
import './ProfileToggle.scss'
import { clearScoutProfileData } from '../../../../redux/scoutFlowControl/scoutFlowControlActions'

const ProfileToggle = ({
  history,
  portalRedirection,
  toggleStartup,
  updateLocalStartupUser,
  updateLocalInvestorUser,
}) => {
  const [activeProfile, setActiveProfile] = useState(false)
  const [activeCompanyInfo, setActiveCompanyInfo] = useState(false)
  const profileData = useSelector(state => state?.scoutflowControl?.profile_data)
  const dispatch = useDispatch()

  // Handles the click event for the profile section, toggling the active state.
  const handleProfileClick = () => {
    setActiveProfile(!activeProfile)
  }

  // Handles the click event for the company info section, toggling the active state and navigating to the scout profile page.
  const handleCompanyInfoClick = () => {
    setActiveCompanyInfo(!activeCompanyInfo)
    history.push('/scout/profile')
  }

  // Handles the click event for the profile setting section, toggling the active state and navigating to the scout settings email notifications page.
  const handleProfileSettingClick = () => {
    setActiveCompanyInfo(!activeCompanyInfo)
    history.push('/scout/settings/carry-recipient')
  }

  // Handles the logout action by clearing local storage, dispatching a logout action, and navigating to the home page.
  const onLogout = () => {
    localStorage.clear()
    dispatch(logoutLocalScoutUser())
    dispatch(clearScoutProfileData())
    history.push('/')
  }

  return (
    <div className="custom-scout-dropdown ml-2">
      <Dropdown isOpen={activeProfile} toggle={handleProfileClick}>
        <DropdownToggle className="dropdown-toggle-btn">
          <Avatar className="scout-avatar-wrap" src={profileData?.profile_pic}>
            {profileData?.first_name?.[0]?.toUpperCase()}
          </Avatar>
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem onClick={handleCompanyInfoClick}>
            <User />
            Profile
          </DropdownItem>
          <DropdownItem onClick={handleProfileSettingClick}>
            <Settings />
            Settings
          </DropdownItem>
          <DropdownItem onClick={onLogout}>
            <LogOut />
            Logout
          </DropdownItem>
          {['investor', 'startup'].includes(localStorage.getItem('login_type')) && (
            <DropdownItem
              className="return-dashboard-item"
              onClick={() => {
                portalRedirection('scout', localStorage.getItem('login_type'))
                  .then(res => {
                    if (res.result) {
                      if (localStorage.getItem('login_type') === 'startup') {
                        if (['tracking', 'rejected', 'pending'].includes(res?.user?.status?.status)) {
                          window.open('/startup/thankyou', '_blank')
                        } else if (res?.user?.status?.status === 'incomplete') {
                          window.open('/startup/onboarding', '_blank')
                        } else {
                          window.open('/startup/approve/dashboard/status', '_blank')
                        }
                        toggleStartup()
                        updateLocalStartupUser(res.user)
                      } else {
                        updateLocalInvestorUser(res.user)
                        if (['pending', 'rejected'].includes(res?.user?.status?.status)) {
                          window.open('/investor/thankyou', '_blank')
                        } else if (res?.user?.status?.status === 'incomplete') {
                          window.open('/investor/onboarding', '_blank')
                        } else {
                          window.open('/investor/deals', '_blank')
                        }
                      }
                    } else {
                      if (res.error === 'user is paused') {
                        window.open('/suspend', '_blank')
                      }
                    }
                  })
                  .catch(err => {
                    if (err?.error === 'user is paused') {
                      window.open('/suspend', '_blank')
                    }
                  })
              }}
            >
              <span style={{ marginTop: '-4px' }}>
                <ReturnDashboardIcon />
              </span>
              <span className="return-dashboard">
                Return to{' '}
                <span style={{ textTransform: 'capitalize' }}>{localStorage.getItem('login_type')}</span>{' '}
                <br />
                Dashboard
              </span>
            </DropdownItem>
          )}
        </DropdownMenu>
      </Dropdown>
    </div>
  )
}

const mapDispatchToProps = dispatch => ({
  portalRedirection: (url, data) => {
    return dispatch(portalRedirection(url, data))
  },
  updateLocalStartupUser: changedProperties => {
    dispatch(updateLocalStartupUser(changedProperties))
  },
  updateLocalInvestorUser: changedProperties => {
    dispatch(updateLocalInvestorUser(changedProperties))
  },
  toggleStartup: () => dispatch(toggleStartup()),
})

export default withRouter(connect(null, mapDispatchToProps)(ProfileToggle))
